<template>
  <div>
    <v-card
      color="background"
      flat>
      <v-card-subtitle
        class="px-0 pb-0 caption">
        NUEVO CONTRATO
      </v-card-subtitle>

      <v-card-title
        class="px-0 pt-0 pb-5">
        Confirmación
      </v-card-title>
    </v-card>

    <v-card>
      <v-card-text>
        <div
          v-if="!!fetchedContract"
        >
          <!-- Plan de contrato -->
          <div class="title black--text font-weight-regular">
            Plan del contrato
          </div>
          <v-list-item 
          class="px-0"
          two-line>
            <v-list-item-content>
              <v-list-item-subtitle>{{ $t('contract.show.panel_one.items.tenant') }}</v-list-item-subtitle>
              <v-list-item-title>{{fetchedContract.tenant[0].profile.name}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            class="px-0"
            two-line>
            <v-list-item-content>
              <v-list-item-subtitle>{{ $t('contract.show.panel_one.items.owner') }}</v-list-item-subtitle>
              <v-list-item-title>{{fetchedContract.owner[0].profile.name}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <div
            class="d-flex flex-row"
            >
            <v-list-item 
              class="px-0"
              two-line>
              <v-list-item-content>
                <v-list-item-subtitle>{{ $t('contract.show.panel_one.items.term') }}</v-list-item-subtitle>
                <v-list-item-title>{{ fetchedContract.duration == 1 ? $t('contract.show.panel_one.items.months.one') : $t('contract.show.panel_one.items.months.n', { n: fetchedContract.duration }) }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              class="px-0"
              two-line>
              <v-list-item-content>
                <v-list-item-subtitle>{{ $t('contract.show.panel_one.items.keys') }}</v-list-item-subtitle>
                <v-list-item-title>{{ fetchedContract.keys }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </div>

          <div
            class="d-flex flex-row"
            >
            <v-list-item 
              class="px-0"
              :key="price.id + price.amount"
              v-for="(price, i) in fetchedContract.rent.prices"
              two-line>
              <v-list-item-content>
                <v-list-item-subtitle>{{ $t('contract.show.panel_one.items.period', { n: parseInt(i) + 1 }) }}</v-list-item-subtitle>
                <v-list-item-title>${{price.amount}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </div>

          <v-list-item 
            class="px-0"
            two-line>
            <v-list-item-content>
              <v-list-item-subtitle>{{ $t('contract.show.panel_one.items.total_contract_price') }}</v-list-item-subtitle>
              <v-list-item-title>${{fetchedContract.totalRentPrice}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <div
            class="d-flex flex-wrap"
            >
            <v-list-item 
              class="px-0"
              :key="tax.id + tax.name"
              v-for="tax in fetchedContract.paymentPlan.taxes.filter( t => t.name != 'Alquiler')"
              two-line>
              <v-list-item-content>
                <v-list-item-subtitle>{{ tax.name }}</v-list-item-subtitle>
                <v-list-item-title>${{ tax.prices[0].amount }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </div>

          <v-divider class="my-6"></v-divider>

           <!-- Plan de pago-->
          <div class="title black--text font-weight-regular">
            Plan de pago 
          </div>
          <v-list-item 
            class="px-0"
            two-line>
            <v-list-item-content>
              <v-list-item-subtitle>{{ $t('contract.show.panel_two.items.fee') }}</v-list-item-subtitle>
              <v-list-item-title>
                {{ fee.prices.length }} cuotas de ${{ fee.prices[0].amount }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item 
            class="px-0"
            two-line>
            <v-list-item-content>
              <v-list-item-subtitle>{{ $t('contract.show.panel_two.items.payment_methods') }}</v-list-item-subtitle>
              <v-list-item-title>
                <span
                  :key="paymentMethod"
                  v-for="(paymentMethod, idx) in fetchedContract.paymentPlan.paymentMethods">
                  {{ paymentMethod + ((idx + 1) == fetchedContract.paymentPlan.paymentMethods.length ? '' : ', ') }}
                </span>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          
          <v-divider class="my-6"></v-divider>

          <!-- Documentación -->
          <div class="title black--text font-weight-regular">
            Documentación
          </div>
          <v-list-item 
            :key="document.id"
            v-for="document in fetchedContract.documents"
            class="pl-0">
            <v-list-item-avatar>
              <v-avatar
                color="grey">
                C
              </v-avatar>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>Contrato</v-list-item-title>
              <v-list-item-subtitle>Archivo del contrato</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn 
                :href="railsBase + document.url" 
                target="_blank"
                icon>
                <v-icon>mdi-cloud-download</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
          <v-subheader
            class="px-0"
            >
            Garantías
          </v-subheader>
          <v-list-item 
            :key="guarantee.id + guarantee.guaranteeType"
            v-for="guarantee in fetchedContract.guarantees"
            class="pl-0">
            <v-list-item-avatar>
              <v-avatar
                color="grey">
                {{ guarantee.guaranteeType.charAt(0) }}
              </v-avatar>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>{{ guarantee.guarantor.profile.name }}</v-list-item-title>
              <v-list-item-subtitle>{{ guarantee.guaranteeType }}</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action
              class="d-flex flex-row">
              <v-btn 
                :key="document.id"
                v-for="document in guarantee.documents"
                :href="railsBase + document.url" 
                target="_blank"
                icon>
                <v-icon>mdi-cloud-download</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>

          <v-subheader
            class="px-0"
            >
            Fotos DNI
          </v-subheader>
          <v-list-item 
            :key="guarantee.id"
            v-for="guarantee in fetchedContract.guarantees"
            class="pl-0">
            <v-list-item-avatar>
              <v-avatar
                color="grey">
                {{ guarantee.guarantor.profile.name.charAt(0) }}
              </v-avatar>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>{{ guarantee.guarantor.profile.name }}</v-list-item-title>
              <v-list-item-subtitle>DNI</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action
              class="d-flex flex-row">
              <v-btn 
                :key="document.id"
                v-for="document in guarantee.guarantor.profile.documents"
                :href="railsBase + document.url" 
                target="_blank"
                icon>
                <v-icon>mdi-cloud-download</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </div>
      </v-card-text>
    </v-card>
    <div
      class="pt-6 text-right">
      <v-btn
        @click="$router.go(-1)"
        text>
        Cerrar y continuar luego
      </v-btn>
      <v-btn
        color="primary"
        @click="nextStep">
        {{ fetchedContract.state == 'draft' ? 'Publicar' : 'Guardar' }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import { EditContract } from '@/graphql/mutations/contracts'

export default {
  props: {
    fetchedContract: {
      type: Object,
      required: true
    }
  },
  computed: {
    fee () {
      return this.fetchedContract.paymentPlan.taxes.find( t => t.name == 'Honorarios' )
    },
    // backend base URL (env-driven) for served files; no trailing slash
    railsBase () {
      return (process.env.VUE_APP_RAILS_URL || "").replace(/\/$/, "")
    }
  },
  methods: {
    nextStep () {
      this.editContract ()
    },

    editContract () {
      this.$apollo.mutate({
        mutation: EditContract,
        variables: {
          input: {
            attributes: {
              state: 'ongoing'
            },
            contractId: this.fetchedContract.id
          }
        }
      }).then(res => {
        this.$emit('continue', res.data.editContract.contract)
      })
    },
  }
}
</script>
